import { forwardRef, type InputHTMLAttributes } from 'react';

export interface TextInputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
}

export const TextInput = forwardRef<HTMLInputElement, TextInputProps>(function TextInput(
  { invalid, style, onFocus, onBlur, ...rest },
  ref,
) {
  return (
    <input
      {...rest}
      ref={ref}
      style={{
        width: '100%',
        height: 40,
        padding: '0 12px',
        borderRadius: 'var(--r-2)',
        border: `1px solid ${invalid ? 'var(--danger)' : 'var(--glass-line-2)'}`,
        background: 'var(--surface)',
        color: 'var(--text)',
        fontSize: 'var(--t-md)',
        fontFamily: 'inherit',
        outline: 'none',
        transition: 'border-color 80ms ease',
        ...style,
      }}
      onFocus={(e) => {
        e.currentTarget.style.borderColor = invalid ? 'var(--danger)' : 'var(--accent)';
        onFocus?.(e);
      }}
      onBlur={(e) => {
        e.currentTarget.style.borderColor = invalid ? 'var(--danger)' : 'var(--glass-line-2)';
        onBlur?.(e);
      }}
    />
  );
});
